import React, { useState, useEffect, useCallback } from 'react';
import BlogCard from './BlogCard';
import { getRelatedBlogs } from '../../Data/RelatedBlogs';

function BlogContainer(props) {
    const [allBlogPosts, setAllBlogPosts] = useState([]);
    const [displayPosts, setDisplayPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    
    // Pagination settings
    const postsPerPage = props.postsPerPage || 6; // Default 6 posts per page

    // Function to change page
    const changePage = useCallback((pageNumber) => {
        setCurrentPage(pageNumber);
    }, []);

    // Expose changePage function to parent component
    useEffect(() => {
        if (props.onPageChange) {
            props.onPageChange(changePage);
        }
    }, [props.onPageChange, changePage]);

    useEffect(() => {
        const loadBlogPosts = async () => {
            try {
                setLoading(true);
                const posts = await getRelatedBlogs();
                if (posts && posts.length > 0) {
                    setAllBlogPosts(posts);
                    
                    // If numberOfPosts is specified, limit the total posts
                    let limitedPosts = posts;
                    if (props.numberOfPosts != null) {
                        limitedPosts = posts.slice(0, props.numberOfPosts);
                    }
                    
                    // Apply pagination
                    const startIndex = (currentPage - 1) * postsPerPage;
                    const endIndex = startIndex + postsPerPage;
                    const paginatedPosts = limitedPosts.slice(startIndex, endIndex);
                    
                    setDisplayPosts(paginatedPosts);
                    
                    // Notify parent component about pagination info
                    if (props.onPaginationChange) {
                        const totalPages = Math.ceil(limitedPosts.length / postsPerPage);
                        props.onPaginationChange({
                            currentPage,
                            totalPages,
                            totalPosts: limitedPosts.length,
                            hasMore: currentPage < totalPages
                        });
                    }
                } else {
                    setAllBlogPosts([]);
                    setDisplayPosts([]);
                }
            } catch (err) {
                setError(err.message);
                setAllBlogPosts([]);
                setDisplayPosts([]);
            } finally {
                setLoading(false);
            }
        };

        loadBlogPosts();
    }, [props.numberOfPosts, currentPage, postsPerPage]); // Removed props.onPaginationChange from dependencies

    if (loading) {
        return (
            <div className="row">
                <div className="col-12 text-center">
                    <div className="loading-spinner">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">Loading blog posts...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="row">
                <div className="col-12 text-center">
                    <p>Error loading blog posts: {error}</p>
                    <p>Please try again later.</p>
                </div>
            </div>
        );
    }

    if (displayPosts.length === 0) {
        return (
            <div className="row">
                <div className="col-12 text-center">
                    <p>No activities available at the moment.</p>
                </div>
            </div>
        );
    }

    return (
        <div
            className="row blog-list-container blog-isotope-container blog-list-container-7bddf04 blog-list-container-grid-1"
            id="7bddf04"
        >
            {displayPosts.map((item, index) => (
                <BlogCard
                    key={item.id || index}
                    width={props.width}
                    image={item.image}
                    date={item.date}
                    designation={item.designation}
                    category={item.category}
                    title={item.title}
                    description={item.description}
                    index={item.index}
                    slug={item.slug}
                />
            ))}
        </div>
    );
}

export default BlogContainer;
